if (typeof QuickView === "undefined") {
  const { FoxThemeStyles, FoxThemeScripts } = window;
  class QuickView {
    constructor() {
      this.modal = null;

      addEventDelegate({
        selector: "[data-product-quickview]",
        handler: (e, target) => {
          e.preventDefault();
          this.target = target;
          target.classList.add("btn--loading");
          const productHandle = target.dataset.productQuickview;
          if (productHandle) this.fetchHtml(productHandle);
        },
      });

      window.FoxThemeEvents.subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
        if (this.modal) this.modal.hide();
      });
    }

    fetchHtml(productHandle) {
      const productUrl = `${window.FoxThemeSettings.base_url}products/${productHandle}`;

      loadAssets(
        [FoxThemeStyles.product, FoxThemeStyles.volumePricing],
        "quick-view-assets"
      );

      const pdpQuickViewRequest = fetchSection("product-quickview", {
        url: productUrl,
      });
      // Fetch PDP to get the Recharge app block
      const productPageRequest = this.fetchProductPage(productUrl).catch(() => null);

      Promise.all([pdpQuickViewRequest, productPageRequest])
        .then(([html, productPage]) => {
          this.modal = html.querySelector("modal-dialog");
          const firstModel = html.querySelector("product-model");
          this.mediaGallery = this.modal.querySelector("media-gallery");
          this.mountRechargeWidget(productPage);
          document.body.appendChild(this.modal);
          loadAssets(
            [
              FoxThemeScripts.productInfo,
              FoxThemeScripts.productMedia,
              FoxThemeScripts.variantsPicker,
              FoxThemeScripts.volumePricing,
            ],
            "variants-picker",
            () => {
              this.modal && this.modal.show(this.target);
              document.dispatchEvent(
                new CustomEvent("quick-view:open", {
                  detail: { productUrl: `/products/${productHandle}` },
                })
              );
              if (this.mediaGallery) {
                const thumb = this.mediaGallery.querySelector(
                  '[id^="GalleryThumbnails"]'
                );
                if (thumb) thumb.update();
                this.mediaGallery.update();
              }
              if (Shopify && Shopify.PaymentButton) {
                Shopify.PaymentButton.init();
              }
              this.target.classList.remove("btn--loading");
              this.handleClose();
              this.toolTip = __reInitTooltip(this.modal);
              this.initializeRechargeWidget();

              document.dispatchEvent(
                new CustomEvent("quick-view:loaded", {
                  detail: { productUrl: `/products/${productHandle}` },
                })
              );

              // Autoship init
              // window.autoship.init();
            }
          );
          if (firstModel) {
            loadAssets(
              [
                FoxThemeScripts.productModel,
                "https://cdn.shopify.com/shopifycloud/model-viewer-ui/assets/v1.0/model-viewer-ui.css",
              ],
              "product-model-assets"
            );
          }
        })
        .catch(console.error);
    }

    async fetchProductPage(productUrl) {
      const response = await fetch(productUrl);
      if (!response.ok) throw new Error("Failed to load product page");
      const html = await response.text();
      return generateDomFromString(html);
    }

    mountRechargeWidget(productPage) {
      if (!this.modal || !productPage) return;

      const quickviewRechargeWidget = this.modal.querySelector("[data-quickview-recharge-widget]");
      const rechargewidget = productPage.querySelector(".recharge-subscription-widget");

      if (quickviewRechargeWidget && rechargewidget) {
        quickviewRechargeWidget.replaceWith(rechargewidget);
      }
    }

    initializeRechargeWidget() {
      const rechargeSubscriptionWidget = this.modal?.querySelector(".recharge-subscription-widget");
      if (!rechargeSubscriptionWidget) return;
      const rechargeScripts = rechargeSubscriptionWidget.querySelectorAll("script");

      rechargeScripts.forEach((oldScript) => {
        const newScript = document.createElement("script");

        for (let i = 0; i < oldScript.attributes.length; i++) {
          const attribute = oldScript.attributes[i];
          newScript.setAttribute(attribute.name, attribute.value);
        }

        newScript.textContent = oldScript.textContent;
        oldScript.replaceWith(newScript);
      });

      const rechargeWebComponent = rechargeSubscriptionWidget.querySelector("recharge-subscription-widget");

      if (rechargeWebComponent) {
        const newRechargeWebComponent = rechargeWebComponent.cloneNode(true);
        rechargeWebComponent.replaceWith(newRechargeWebComponent);
      }
    }

    handleClose() {
      if (!this.modal) return;
      this.modal.addEventListener("close", () => {
        const allTooltip = [
          ...(this.modal.querySelector("product-info")?.toolTip || []),
          ...(this.toolTip || []),
        ];
        allTooltip.forEach((item) => item.unmount());

        const quantityInputs = this.modal.querySelectorAll("quantity-input");
        quantityInputs.forEach((input) => {
          input.disconnectedCallback();
        });

        this.modal.remove();
      });
    }
  }
  new QuickView();
  window.QuickView = QuickView;
}
